import React, { memo, useEffect, useState } from "react";
import styles from "./TimerButton.module.scss";

type Props = {
	timerLength: number;
	onClick: () => void;
};

const TimerButton: React.FC<Props> = memo((props: Props) => {
	const { timerLength, onClick } = props;

	const [timer, setTimer] = useState(timerLength);

	useEffect(() => {
		const interval = setInterval(() => {
			if (timer > 0) {
				setTimer(timer - 1);
			}
		}, 1000);

		return () => clearInterval(interval);
	}, [timer]);

	const convertSecondsToTime = (seconds: number) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;

		return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
	};

	const handleClick = () => {
		if (timer === 0) {
			setTimer(timerLength);
			onClick();
		}
	};

	return (
		<button className={`standardButton ${styles.button} ${timer > 0 ? styles.timerActive : ""}`} onClick={handleClick}>
			{timer > 0 ? (
				<>
					    <span>Resend in</span>
						 <b>{convertSecondsToTime(timer)}</b>
				</>
			) : (
				<>Resend</>
			)}
		</button>
	);
});

export default TimerButton;
